export const statsPerTemplateGeneral = {
  playerCompare: {
    striker: [
      {
        title: "Tore",
        key: "goals",
      },
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
      },
      {
        title: "Assists",
        key: "goalAssist",
      },
      {
        title: "Torschussvorlagen",
        key: "totalAttAssist",
      },
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["duelLost", "duelWon"],
        calc: "##duelWon##/((##duelLost##+##duelWon##)/100)",
      },
    ],
    midfielder: [
      {
        title: "Tore",
        key: "goals",
      },
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
      },
      {
        title: "Assists",
        key: "goalAssist",
      },
      {
        title: "Torschussvorlagen",
        key: "totalAttAssist",
      },
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["duelLost", "duelWon"],
        calc: "##duelWon##/((##duelLost##+##duelWon##)/100)",
      },
    ],
    defender: [
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Präzise Pässe",
        key: "accuratePass",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Zweikämpfe",
        key: "calcTotalDuels",
        deps: ["duelLost", "duelWon"],
        calc: "##duelLost##+##duelWon##",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["duelLost", "duelWon"],
        calc: "##duelWon##/((##duelLost##+##duelWon##)/100)",
      },
      {
        title: "gew. Zweikämpfe",
        key: "duelWon",
      },
      {
        title: "Fouls",
        key: "fouls",
      },
    ],
    goalkeeper: [
      {
        title: "Ballaktionen",
        key: "touches",
      },
      {
        title: "Paraden",
        key: "saves",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Gegentore",
        key: "goalsConceded",
      },
      {
        title: "Spielminuten",
        key: "minsPlayed",
      },
      {
        title: "Fouls",
        key: "fouls",
      },
    ],
  },
  playerCompareSeason: {
    midfielder: [
      {
        title: "Spiele",
        key: "Games Played",
      },
      {
        title: "Tore",
        key: "Goals",
      },
      {
        title: "Torschüsse",
        key: "Shots On Target ( inc goals )",
      },
      {
        title: "Assists",
        key: "Goal Assists",
      },
      {
        title: "Torschussvorlagen",
        key: "Key Passes (Attempt Assists)",
      },
      {
        title: "Ballaktionen",
        key: "Touches",
      },
    ],
    forward: [
      {
        title: "Spiele",
        key: "Games Played",
      },
      {
        title: "Tore",
        key: "Goals",
      },
      {
        title: "Torschüsse",
        key: "Shots On Target ( inc goals )",
      },
      {
        title: "Assists",
        key: "Goal Assists",
      },
      {
        title: "Torschussvorlagen",
        key: "Key Passes (Attempt Assists)",
      },
      {
        title: "Ballaktionen",
        key: "Touches",
      },
    ],
  },
  teamCompare: {
    offensive: [
      {
        title: "Torschüsse",
        key: "totalScoringAtt",
      },
      {
        title: "Schüsse aufs Tor",
        key: "ontargetScoringAtt",
      },
      {
        title: "Big Chances",
        key: "bigChanceCreated",
      },
      {
        title: "Chancenverwertung in %",
        key: "calcChancesCreated",
        deps: ["goals", "totalScoringAtt"],
        calc: "(##goals##/##totalScoringAtt##)*100",
      },
      {
        title: "Ecken",
        key: "cornerTaken",
      },
      {
        title: "Erfolgreiche Dribblings in %",
        key: "calcSuccessContest",
        deps: ["wonContest", "totalContest"],
        calc: "(##wonContest##/##totalContest##)*100",
      },
    ],
    defensive: [
      {
        title: "Ballbesitz in %",
        key: "possessionPercentage",
      },
      {
        title: "Pässe gesamt",
        key: "totalPass",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: ["accuratePass", "totalPass"],
        calc: "##accuratePass##/(##totalPass##/100)",
      },
      {
        title: "Anzahl Zweikämpfe",
        key: "calcZweikampfAnzahl",
        deps: ["duelLost", "duelWon"],
        calc: "##duelLost##+##duelWon##",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["duelLost", "duelWon"],
        calc: "##duelWon##/((##duelLost##+##duelWon##)/100)",
      },
      {
        title: "Fouls",
        key: "fkFoulLost",
      },
    ],
  },
  teamCompareSeason: {
    offensive: [
      {
        title: "Tore",
        key: "Goals",
      },
      {
        title: "Torschüsse",
        key: "calcTotalShotsAndBlocked",
        deps: ["Total Shots", "Blocked Shots"],
        calc: "##Total Shots##+##Blocked Shots##",
      },
      {
        title: "Schüsse aufs Tor",
        key: "Shots On Target ( inc goals )",
      },
      {
        title: "Total touches in opposition box",
        key: "Total touches in opposition box",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: [
          "Total Successful Passes ( Excl Crosses & Corners ) ",
          "Total Passes",
        ],
        calc: "##Total Successful Passes ( Excl Crosses & Corners ) ##/(##Total Passes##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["Duels lost", "Duels won"],
        calc: "##Duels won##/((##Duels lost##+##Duels won##)/100)",
      },
    ],
    defensive: [
      {
        title: "Schüsse aufs Tor",
        key: "Shots On Target ( inc goals )",
      },
      {
        title: "Fouls",
        key: "Total Fouls Conceded",
      },
      {
        title: "Ecken",
        key: "Corners Taken (incl short corners)",
      },
      {
        title: "Total touches in opposition box",
        key: "Total touches in opposition box",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: [
          "Total Successful Passes ( Excl Crosses & Corners ) ",
          "Total Passes",
        ],
        calc: "##Total Successful Passes ( Excl Crosses & Corners ) ##/(##Total Passes##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["Duels lost", "Duels won"],
        calc: "##Duels won##/((##Duels lost##+##Duels won##)/100)",
      },
    ],
  },
  teamLast10CompareSeason: {
    offensive: [
      {
        title: "Tore",
        key: "Goals",
      },
      {
        title: "",
        key: "Goals Conceded"
      }
    ],
    defensive: [
      {
        title: "Schüsse aufs Tor",
        key: "Shots On Target ( inc goals )",
      },
      {
        title: "Fouls",
        key: "Total Fouls Conceded",
      },
      {
        title: "Ecken",
        key: "Corners Taken (incl short corners)",
      },
      {
        title: "Total touches in opposition box",
        key: "Total touches in opposition box",
      },
      {
        title: "Passquote in %",
        key: "calcPassquote",
        deps: [
          "Total Successful Passes ( Excl Crosses & Corners ) ",
          "Total Passes",
        ],
        calc: "##Total Successful Passes ( Excl Crosses & Corners ) ##/(##Total Passes##/100)",
      },
      {
        title: "Zweikampfquote in %",
        key: "calcZweikampfquote",
        deps: ["Duels lost", "Duels won"],
        calc: "##Duels won##/((##Duels lost##+##Duels won##)/100)",
      },
    ],
  },
  teamGoalmouth: [
    {
      title: "Schüsse",
      key: "totalScoringAtt",
    },
    {
      title: "Torschüsse",
      key: "ontargetScoringAtt",
    },
    {
      title: "Tore",
      key: "goals",
    },
    {
      title: "Paraden %",
      key: "calcParaden",
      deps: ["#VERSUS#saves", "ontargetScoringAtt"],
      calc: "#VERSUS#saves##/((##ontargetScoringAtt##)/100)",
    },
  ],
  ofTeamGoalmouth: [
    {
      title: "Schüsse",
      key: "totalScoringAtt",
    },
    {
      title: "Tore",
      key: "goals",
    },
    {
      title: "Paraden %",
      key: "calcParaden",
      deps: ["#VERSUS#saves", "ontargetScoringAtt"],
      calc: "#VERSUS#saves##/((##ontargetScoringAtt##)/100)",
    },
  ],
  playerHeatmap: [
    {
      title: "Ballaktionen",
      key: "touches",
    },
    {
      title: "Passquote in %",
      key: "calcPassquote",
      deps: ["accuratePass", "totalPass"],
      calc: "##accuratePass##/(##totalPass##/100)",
    },
    {
      title: "Pässe gesamt",
      key: "totalPass",
    },
  ],
};
